import * as React from 'react';

import EmailMarketingSvg from '../assets/email-marketing.svg';

import styles from './help-graphic-closed-lead-email-marketing.module.css';

export class HelpGraphicClosedLeadEmailMarketing extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <EmailMarketingSvg />
            </div>
        );
    }
}
